import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import './index.css';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import LegalExplanation from './pages/LegalExplanation';
import Research from './pages/Research';
import About from './pages/About';
import { SearchFilesProvider } from './contexts/SearchFilesContext';

function App() {
  return (
    <SearchFilesProvider>
      <Router>
        <div className="App">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/index" element={<Navigate to="/" />} />
              <Route path="/site/explanation" element={<LegalExplanation />} />
              <Route path="/research/navigation" element={<Research />} />
              <Route path="/about" element={<About />} />
              <Route path="/legal-explanation" element={<LegalExplanation />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </SearchFilesProvider>
  );
}

export default App;